<div class="back-to-top" *ngIf="shouldShowButton">
  <button (click)="onTopClick()" class="btn-icon icon__back-to-top">
    <picture>
      <source type="image/webp" srcset="/assets/imgs/icons/AmiLearn-Icon_ArrowUp_Reverse.webp">
      <source type="image/png" srcset="/assets/imgs/icons/AmiLearn-Icon_ArrowUp_Reverse.png">
      <img type="image/png" src="/assets/imgs/icons/AmiLearn-Icon_ArrowUp_Reverse.png" width="26" height="26" alt="" title="Back to Top">
    </picture>
    <span class="sr-text">back to top</span>
  </button>
</div>
